import { type AxiosInstance } from "axios";
import { type StoredPicturesDownloadCondition } from "@/types/storedPicturesDownloadCondition";
import { manualSearchResponseSchema } from "../schemas";
import {
  type AiStoredPicturesChatResponse,
  type ManualSearchResult,
} from "../types";

const CHAT_ENDPOINT = "/ai-agent/stored-pictures/chat";
const DOWNLOAD_ENDPOINT = "/picture-request/stored-pictures/download";
export const MANUAL_SEARCH_ENDPOINT = "/ai-agent/manual/search";

export const postAiStoredPicturesChat = async (
  apiClient: AxiosInstance,
  message: string
): Promise<AiStoredPicturesChatResponse> => {
  const response = await apiClient.post<AiStoredPicturesChatResponse>(
    CHAT_ENDPOINT,
    { message }
  );
  return response.data;
};

export const postManualSearch = async (
  apiClient: AxiosInstance,
  message: string
): Promise<ManualSearchResult[]> => {
  const response = await apiClient.post<unknown>(MANUAL_SEARCH_ENDPOINT, {
    message,
  });
  return manualSearchResponseSchema.parse(response.data);
};

export const postAiStoredPicturesDownload = async (
  apiClient: AxiosInstance,
  condition: StoredPicturesDownloadCondition
): Promise<number> => {
  const response = await apiClient.post<{ pictureRequestId: number }>(
    DOWNLOAD_ENDPOINT,
    {
      billableData: condition.billableData.map(({ receivedId }) => ({
        id: receivedId,
      })),
      noBillableData: condition.noBillableData,
    }
  );
  return response.data.pictureRequestId;
};
